export default {
  user: {},
  destination: '',
  currentCustomer: '',
}
